// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  BackgroundLayerKind,
} from "./types";

export default {
  catalogRef: __t.string(),
  get kind() {
    return BackgroundLayerKind;
  },
  name: __t.string(),
  sourceUrl: __t.string(),
  attribution: __t.string(),
  apiKey: __t.string(),
  dailyRequestCap: __t.u32(),
  maxZoom: __t.u32(),
  enabled: __t.bool(),
  opacity: __t.f32(),
  layerOrder: __t.i32(),
};
